// extracted by mini-css-extract-plugin
module.exports = {"graphPrimary":"#11274a","graphSecondary":"#d5213c"};